import { useNavigate } from "react-router-dom";

import { ROUTE_PATHS } from "@routes/routePath";

interface Args {
  draftArticleId: string;
  nctNumber: string;
}

export const useMoveCtgDetailPage = ({ draftArticleId, nctNumber }: Args) => {
  const navigate = useNavigate();

  const moveCtgDetailPage = () => {
    const pathname = ROUTE_PATHS.ctgFillInTable;
    const url = `${pathname}?id=${draftArticleId}&nctNumber=${nctNumber}`;

    navigate(url);
  };

  return {
    moveCtgDetailPage,
  };
};
